import { render } from "./SuspenseWithError.vue?vue&type=template&id=6602bc96"
import script from "./SuspenseWithError.vue?vue&type=script&lang=js"
export * from "./SuspenseWithError.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__